"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoreEthType = void 0;
var CoreEthType;
(function (CoreEthType) {
    CoreEthType["ADD_LISTENER"] = "ADD_LISTENER";
    CoreEthType["REMOVE_LISTENER"] = "REMOVE_LISTENER";
    CoreEthType["START_LOTTERY_ROUND"] = "START_LOTTERY_ROUND";
    CoreEthType["START_RAFFLE_ROUND"] = "START_RAFFLE_ROUND";
})(CoreEthType || (exports.CoreEthType = CoreEthType = {}));
//# sourceMappingURL=core-eth.js.map